import { laptopMediumMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import platform from '@propertypal/shared/src/utils/platform';
import styled from 'styled-components';

export const Container = styled.div<{ $padding?: number }>`
  background: ${({ theme }) => platform.select('transparent', theme.background)};
  display: flex;
  flex-direction: row;
  padding: 10px ${({ $padding }) => (typeof $padding !== 'undefined' ? $padding : '30')}px;
  justify-content: space-between;

  @media (${laptopMediumMax}) {
    padding: 10px 15px;
  }

  @media (${mobileXXLargeMax}) {
    display: ${platform.select('none', 'flex')};
  }
`;

export const BackLink = styled.button`
  font-size: 12px;
  color: ${(props) => props.theme.primary};
  margin-right: 20px;
  cursor: pointer;
  transition: 300ms all;
  white-space: nowrap;
  overflow: hidden;

  &:hover {
    color: ${(props) => props.theme.textLight};
  }
`;

export const Crumbs = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  flex: 1;

  @media (${mobileXXLargeMax}) {
    display: none;
  }
`;

export const Crumb = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.textLight};
  margin-right: 3px;

  &:hover {
    color: ${(props) => props.theme.textDark};
  }

  &:last-child {
    font-weight: bold;
    color: ${(props) => props.theme.textDark};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const NextBackLinks = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.textLight};
  margin-left: 15px;

  a:hover {
    color: ${(props) => props.theme.textDark};
  }
`;
